import { render } from "./IconDone.vue?vue&type=template&id=97560064"
import script from "./IconDone.vue?vue&type=script&lang=js"
export * from "./IconDone.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__